module.exports = __webpack_public_path__ + "media/AtmPinPad_Mobile.c2fe8bdd.mp4";